import { SET_CART_DATA, SET_QUOTE_DATA, MODAL_SHOW, MODAL_TYPE_ERROR, RESET_CART_DATA, RESET_QUOTE_DATA,  UPDATE_POLICY_LOADER_SCREEN_HIDE, UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW, UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE, QUOTE_LOADING_SCREEN_HIDE, QUOTE_LOADING_SCREEN_SHOW, SET_CUSTOMER_DATA, PRODUCT_PORTABLE_POSSESSIONS, PRODUCT_COMPREHENSIVE_CAR  } from "../constants/constants"
import { navigateTo } from "./navigationActions";
import { DASHBOARD, QUOTATION, BANKING_DETAILS, PERSONAL_INSURANCE } from "../routes/routes";
import { postToController, logErrorToDatabase } from "./apiActions";
import { ERROR_HEADER, ERROR_SOMETHING_WENT_WRONG } from "../constants/copy";
import { hideModal } from "./modalActions";
import { removeAcceptedBlingQuote } from "./salesActions";
import { logEvent } from "../firebase/firebase";
import {showModalCalculatorBroke} from "./salesModalActions";

export const refreshCart = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetCartData', JSON.stringify({
            Parameter: getState().sales.quoteId,
        })).then(async (cartProducts) => {
            if (cartProducts.premiumCalculationError){
                dispatch(showModalCalculatorBroke());
            }
            else{
                await dispatch({
                    type: SET_CART_DATA, payload: {
                        products: cartProducts.products,
                        quote: getState().sales.quote,
                        quoteId: getState().sales.quoteId,
                        premiumCalculationError: cartProducts.premiumCalculationError
                    }
                });
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        carPremium: cartProducts.premuim
                    }
                });
            }
        })
    };
}

export const refreshUpdatedCartItem = () => {
    return async (dispatch, getState) => {
        await dispatch(refreshCart());
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                isNewItem: true,
            }
        });
        dispatch(navigateTo(BANKING_DETAILS));
    };
}

export const removeProductFromCart = (carId) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_remove_cover_from_quote_cart', getState().sales.quoteId + '/' + carId);
        await postToController(dispatch, 'RemoveRiskItemFromQuote', JSON.stringify({
            QuoteId: getState().cart.quoteId,
            RiskItemId: carId,
        })).then(async (response) => {
            if (response !== null) {
                var acceptedBlingItems = getState().sales.acceptedBlingCovers;
                if (acceptedBlingItems == undefined) {
                    acceptedBlingItems = [];
                }
                await dispatch(removeAcceptedBlingQuote(carId))
                await dispatch(refreshCart());
            } else {
                logErrorToDatabase("Error removing risk item in cartActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error removeProductFromCart, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }).finally(() => {
            dispatch(hideModal())
        });
        dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
        dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
        setTimeout(() => {
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            dispatch(navigateTo(BANKING_DETAILS))
        }, 1000);
    }
}

export const removeProductFromCartNavigate = (carId) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        if (carId === "blingcovers") {
            var acceptCovers = getState().sales.acceptedBlingCovers;
            if (acceptCovers == undefined) {
                acceptCovers = [];
            }
            
            await postToController(dispatch, 'AcceptBlingQuote', JSON.stringify(
                {
                    quoteId: getState().sales.quoteId,
                    AcceptedItems: acceptCovers,
                    RemovedRiskItemIds: null,
                }
            )).then(async (response) => {

                if (response !== "Failure" && response !== "") {
                    await dispatch(removeAcceptedBlingQuote(carId))
                    dispatch(refreshCart());
                } else {
                    logErrorToDatabase("Error removing bling cover in cartActions");
                }
            }).catch((err) => {
                logErrorToDatabase("Error accept bling quote submit, Error: " + err);
            }).finally(() => {
                dispatch(hideModal())
            })
        }
        else {
            await postToController(dispatch, 'RemoveRiskItemFromQuote', JSON.stringify({
                QuoteId: getState().cart.quoteId,
                RiskItemId: getState().sales.quoteScreenRiskId,
            })).then(async (response) => {
                if (response !== null) {
                    await dispatch(refreshCart());
                } else {
                    logErrorToDatabase("Error removing risk item in cartActions");
                }
            }).catch((err) => {
                logErrorToDatabase("Error removeProductFromCart, Error: " + err);
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }).finally(() => {
                dispatch(hideModal())
            });
        }
        dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
        dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
        setTimeout(() => {
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
        }, 1000);
    }
}

export const editItem = (carId) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        /* eslint eqeqeq: "off" */
        let cartItem = getState().cart.products.find(element => element.riskItemId === carId);
        logEvent('SSP_edit_cover_on_quote', getState().sales.quoteId + '/' + carId);
        if (cartItem.name === "Portable possessions") {
            /* eslint eqeqeq: "warn" */
            await dispatch({
                type: SET_QUOTE_DATA, payload: {
                    portableItemDetails: {
                        excess: 500,
                        grossPremium: 0,
                        premium: cartItem.premium,
                        proRataPremium: cartItem.proRata,
                        quoteCoverId: "00000000-0000-0000-0000-000000000000",
                        quoteId: getState().sales.quoteId,
                        replacementValue: cartItem.replacementValue,
                        riskItemId: cartItem.riskItemId,
                        quoteType: PRODUCT_PORTABLE_POSSESSIONS,
                    }
                },
            });
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
                dispatch(navigateTo(QUOTATION))
            }, 1000);
        }
        else {
            /* eslint eqeqeq: "warn" */
            await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                QuoteId: getState().sales.quoteId,
                QuoteRiskItemId: carId,
                RiskItemId: carId,
            })).then(async (carDetailsResponse) => {
                if (carDetailsResponse.premiumError){
                    dispatch(showModalCalculatorBroke());
                }
                else {
                    await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                        Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                        ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                        ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions
                    })).then(async (excessResponse) => {
                        await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                            Parameter: getState().profile.countryId,
                        })).then(async (vapOptions) => {
                            await dispatch({
                                type: SET_QUOTE_DATA, payload: {
                                    coverId: carDetailsResponse.carDetails.carDetails.quoteCoverId,
                                    carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2),
                                    excessList: excessResponse,
                                    selectedExcess: {
                                        description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                        id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                    },
                                    carId: carId,
                                    carDetails: carDetailsResponse.carDetails.carDetails,
                                    tyreAndRimOptions: vapOptions.tyreAndRim,
                                    littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                    carHireOptions: vapOptions.carHire,
                                    balloonOptions: vapOptions.baloonPercentage,
                                    isNewItem: false,
                                    totalPremium: carDetailsResponse.totalPremium,
                                    quoteType: PRODUCT_COMPREHENSIVE_CAR,
                                },
                            });
                            dispatch({type: QUOTE_LOADING_SCREEN_HIDE});
                            dispatch({type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW});
                            setTimeout(() => {
                                dispatch({type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE});
                                dispatch(navigateTo(QUOTATION))
                            }, 1000);
                            //await dispatch(navigateTo(QUOTATION));
                        }).catch(err => {
                            logErrorToDatabase("Error GetVapOptions in cartActions: " + err);
                            dispatch({
                                type: MODAL_SHOW,
                                modalProps: {
                                    type: MODAL_TYPE_ERROR,
                                    header: ERROR_HEADER,
                                    body: ERROR_SOMETHING_WENT_WRONG,
                                }
                            });
                        })
                    }).catch(err => {
                        logErrorToDatabase("Error GetExcessSelection in cartActions: " + err);
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                    })
                }
            }).catch(err => {
                logErrorToDatabase("Error GetCarDetails in cartActions: " + err);
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            })
        }

        dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
    };
}

export const discardCart = () => {
    return async (dispatch) => {

        await dispatch({
            type: RESET_CART_DATA, payload: {}
        });
        await dispatch({
            type: RESET_QUOTE_DATA, payload: {
            }
        });
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                isLinked: true,
            }
        });
        await dispatch(navigateTo(PERSONAL_INSURANCE));
    };
}

export const discardCartPortable = () => {
    return (dispatch) => {

        dispatch({
            type: RESET_CART_DATA, payload: {}
        });
        dispatch({
            type: RESET_QUOTE_DATA, payload: {
            }
        });
        dispatch(navigateTo(DASHBOARD));
    };
}

export const discardCartCollectable = () => {
    return (dispatch) => {

        dispatch({
            type: RESET_CART_DATA, payload: {}
        });
        dispatch({
            type: RESET_QUOTE_DATA, payload: {
            }
        });
    };
}